import React from 'react';

function AboutApp() {
  return (
    <div className="about-app">
      <h2>Про додаток</h2>
      <p>
        Цей додаток допомагає користувачам отримувати інформацію про погоду у різних містах та дізнаватися рекомендації щодо одягу на основі погодних умов.
      </p>
      <p>
        Введіть місто та дату, щоб дізнатися погодні умови та рекомендації щодо одягу на вибраний день.
      </p>
      <p>
        Додаток використовує дані з API OpenWeatherMap.
      </p>
    </div>
  );
}

export default AboutApp;
